import script from "./stage.vue?vue&type=script&setup=true&lang=js"
export * from "./stage.vue?vue&type=script&setup=true&lang=js"

import "./stage.vue?vue&type=style&index=0&id=7336716e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7336716e"]])

export default __exports__